import React, { Component } from 'react';
import Navigation from '../Navigation';
import Notificaciones from '../overview/Notificaciones';
import axios from 'axios';
import { CSVLink } from 'react-csv';
import { withRouter } from 'react-router-dom';
/*function convertirfecha(fecha) {
    if (fecha !== '') {
        //console.log(this.state.sitios[i].fechalectura);
        var fec = new Date("" + fecha + "");
        var hora = fec.toLocaleTimeString();
        var dia = fec.toLocaleDateString();
        return dia + ' ' + hora;
    } else {
        return '-';
    }
};*/


export class Lecturas extends Component {
    constructor(props) {
        super(props);
        this.state = {
            lecturas: [],
            fecha1:'',
            fecha2:'',
            sitio:''
        };
    }
    
   
    
    fecha1(event){
        this.setState({fecha1:event.target.value});
        
    };
    fecha2(event){
        this.setState({fecha2:event.target.value});
    };
    async cargarlecturas(){        
        const res = await axios.get('https://api.instrutronica-iot.com/api/pruebas/lecturas6/fechas/' + this.state.sitio+'/'+this.state.fecha1+'/'+this.state.fecha2);
        this.setState({ lecturas: res.data});             
    };
    
   

    async componentDidMount() {
        var query = window.location.href;
        var sit = query.split("/");
        const res = await axios.get('https://api.instrutronica-iot.com/api/pruebas/lecturas6/hoy/' + sit[5]);
        this.setState({ lecturas: res.data });
        this.setState({sitio: sit[5]});

        this.interval =  setInterval(async() =>{
            if(localStorage.getItem('pruebas_app')==null){
                this.props.history.push("/");
            }
        },1000);

    }

    render() {
        let count=1;
        return (
            <div>
                <Navigation></Navigation>
                <div className="page">

                    <header className="header">
                        <nav className="navbar">
                            <div className="container-fluid">
                                <div className="navbar-holder d-flex align-items-center justify-content-between">
                                    <div className="navbar-header"><button id="toggle-btn" className="menu-btn btn-dark"><i className="icon-bars"> </i></button><span href="index.html" className="navbar-brand">
                                        <div className="brand-text d-none d-md-inline-block"><span style={{ color: "#ccc" }}>{} </span><strong className="text-primary"> {}</strong></div></span></div>
                                    <Notificaciones></Notificaciones>
                                </div>
                            </div>
                        </nav>
                    </header>
                    <div className="breadcrumb-holder">
                        <div className="container-fluid">
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item">Vista General</li>
                                <li className="breadcrumb-item active">Lecturas       </li>
                            </ul>
                        </div>
                    </div>

                    <section>
                        <div className="container-fluid">
                            <header>
                                <h1 className="h3 display">Lecturas            </h1>
                                <p>Para descargar un reporte primero cargue las lecturas y después presione el botón Descargar CSV</p>
                            </header>
                            <div className="row">
                                <div className="col-lg-12">

                                    <div className="input-group">
                                        <input id="fecha1" onChange={this.fecha1.bind(this)}  type="date" className="form-control" placeholder="Fecha Inicial" aria-label="Fecha Inicial" aria-describedby="button-addon4"></input>
                                        <input id="fecha2" onChange={this.fecha2.bind(this)} type="date" className="form-control" placeholder="Fecha Final" aria-label="Fecha fianl" aria-describedby="button-addon4"></input>
                                        <div className="input-group-append" id="button-addon4">
                                            <button className="btn  btn-success" type="button" onClick={this.cargarlecturas.bind(this)}>Cargar Lecturas</button>
                                            <CSVLink className="btn btn-info"
                                                data={this.state.lecturas}
                                                asyncOnClick={true}
                                                filename={"reporte.csv"}                                                
                                                >
                                                Descargar CSV
                                                </CSVLink>
                                        </div>
                                    </div>




                                </div>
                                <div className="col-lg-12">
                                    <div className="card">
                                        <div className="card-header">
                                            <h4>Lecturas del dia de hoy</h4>
                                        </div>
                                        <div className="card-body">
                                            <div className="table-responsive">
                                                <table className="table table-striped table-hover">
                                                    <thead>
                                                        <tr>
                                                            <th>#</th>
                                                            <th>Fecha</th>
                                                            <th>Caudal L/S</th>
                                                            <th>Volumen M3</th>
                                                            <th>pH</th>
                                                            <th>ph mV</th>
                                                            <th>ORP mV</th>
                                                            <th>Conductividad Real (µS/cm)</th>
                                                            <th>Conductividad Específica (µS/cm)</th>                                                           
                                                            <th>Salinidad PSU</th>                                 
                                                            <th>Sólidos Disueltos ppt</th>
                                                            <th>Resistividad (Ω⋅cm)</th>
                                                            <th>Densidad (g/cm³)</th>
                                                            <th>Turbidez (NTU)</th>
                                                            <th>Sólidos en Suspensión (mg/L)</th>
                                                            <th>Concentración RDO (mg/L)</th>
                                                            <th>Saturación RDO (%Sat)</th>
                                                            <th>Presión Barométrica (mm Hg)</th>
                                                            <th>Presión Parcial de Oxígeno (Torr)</th>
                                                            <th>Temperatura</th>
                                                            <th>Elevación</th>                                                        
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            
                                                            this.state.lecturas.map(function (lectura) {
                                                                return <tr key={lectura._id}>
                                                                    <th scope="row">{count++}</th> 
                                                                    <td>{(!lectura.fechalec)?(lectura.fechalectura):(lectura.fechalec)}</td> 
                                                                    <td>{(lectura.caudal===null) ? 'null':(lectura.caudal)}</td>
                                                                    <td>{(lectura.volumen===null) ? 'null':(lectura.volumen)}</td> 
                                                                    <td>{(lectura.ph===null) ? 'null':(lectura.ph)}</td>
                                                                    <td>{(lectura.phmv===null) ? 'null':(lectura.phmv)}</td>
                                                                    <td>{(lectura.orp===null) ? 'null':(lectura.orp)}</td>
                                                                    <td>{(lectura.conductividad===null) ? 'null':(lectura.conductividad)}</td>
                                                                    <td>{(lectura.conductividad_e===null) ? 'null':(lectura.conductividad_e)}</td>
                                                                    <td>{(lectura.salinidad===null) ? 'null':(lectura.salinidad)}</td>
                                                                    <td>{(lectura.solidos_disueltos===null) ? 'null':(lectura.solidos_disueltos)}</td>
                                                                    <td>{(lectura.resistividad===null) ? 'null':(lectura.resistividad)}</td>                                                                    
                                                                    <td>{(lectura.densidad===null) ? 'null':(lectura.densidad)}</td>                                                                    
                                                                    <td>{(lectura.turbiedad===null) ? 'null':(lectura.turbiedad)}</td>
                                                                    <td>{(lectura.solidos_susp===null) ? 'null':(lectura.solidos_susp)}</td>
                                                                    <td>{(lectura.oxigeno_dis===null) ? 'null':(lectura.oxigeno_dis)}</td>
                                                                    <td>{(lectura.saturacion_ox===null) ? 'null':(lectura.saturacion_ox)}</td>
                                                                    <td>{(lectura.presion_bar===null) ? 'null':(lectura.presion_bar)}</td>
                                                                    <td>{(lectura.presion_par_ox===null) ? 'null':(lectura.presion_par_ox)}</td>                                                                    
                                                                    <td>{(lectura.temperatura===null) ? 'null':(lectura.temperatura)}</td>
                                                                    <td>{(lectura.elevacion===null) ? 'null':(lectura.elevacion)}</td>
                                                                   
                                                                    
                                                                </tr>;
                                                            })
                                                        }


                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <footer className="main-footer">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-sm-6">
                                    <p>Instrutrónica -Liderti &copy; 2019</p>
                                </div>
                                <div className="col-sm-6 text-right">
                                    <p>Version 1.0.0</p>
                                </div>
                            </div>
                        </div>
                    </footer>
                </div>
            </div>
        )
    }
}

export default withRouter(Lecturas)
